export default "__VITE_ASSET__C7_H3jVd__"